<template>
  <nav
    style="justify-content: flex-start"
    class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating"
  >
    <div>
      <button class="btn btn-outline" id="menu-toggle" @click="sidebar">
        <span class="navbar-toggler-icon"></span>
      </button>

      <button
        style="color: rgba(0, 0, 0, 0.5); border-color: rgba(0, 0, 0, 0.1)"
        class="btn btn-outline navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span style="padding-top: 0.5em"
          ><i class="fas fa-user-alt"></i><span class="account-div"></span
          ><i class="fas fa-angle-down"></i
        ></span>
      </button>
    </div>
    <div class="d-flex">
      <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
      <div v-for="(item, index) in breadcrumb" :key="index">
        <router-link
          v-if="index < breadcrumb.length - 1 && item.link !== 'undefined'"
          :class="['mb-0 link']"
          :to="item.link"
        >
          <span v-if="index !== 0">&nbsp;/&nbsp;</span>{{ item.name }}
        </router-link>
        <span
          v-else-if="index < breadcrumb.length - 1 || breadcrumb.length === 1"
          class="mb-0 link"
          :class="[{ 'text-blue': breadcrumb.length === 1 }]"
          style="cursor: default"
          >&nbsp;{{ item.name }}</span
        >
        <span v-else class="mb-0 link active-page"
          >&nbsp;/&nbsp;{{ item.name }}</span
        >
      </div>
    </div>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
        <li class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="navbarDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            {{ admin }}
          </a>
          <div
            class="dropdown-menu dropdown-menu-right"
            aria-labelledby="navbarDropdown"
          >
            <router-link
              class="dropdown-item d-flex align-items-center"
              style="gap: 0.5em"
              to="/password"
            >
              <i class="fas fa-cog"></i
              ><span class="right-dropdown">Change Password</span>
            </router-link>
            <a
              class="dropdown-item link d-flex align-items-center"
              style="gap: 0.5em"
              @click="handleLogout"
              ><i class="fas fa-sign-out-alt"></i
              ><span class="right-dropdown">Logout</span></a
            >
          </div>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Navbar",
  props: {
    customBreadcrumb: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      admin: "",
    };
  },
  computed: {
    breadcrumb() {
      if (this.customBreadcrumb.length > 0) {
        return this.customBreadcrumb;
      }
      if (
        this.$route.meta &&
        this.$route.meta.breadcrumbs &&
        this.$route.meta.breadcrumbs.length > 0
      ) {
        const meta = this.$route.meta.breadcrumbs;
        return meta.map((item) => {
          const query = !item.query
            ? ""
            : Object.entries(item.query).reduce((acc, key) => {
                acc += `${key[0]}=${key[1]}&`;
                return acc;
              }, "");
          return {
            name: item.name,
            link: `${item.path}${query ? `?${query}` : ""}`,
            color: item.color || null,
          };
        });
      }
      return [];
    },
  },
  methods: {
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(
          process.env.LOGOUT,
          {},
          {
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          }
        );
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          });
          return;
        }
      } catch (error) {
        if (error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          });
          return;
        }
      }
      localStorage.removeItem("jwt");
      localStorage.removeItem("admin_name");
      localStorage.removeItem("roles");
      localStorage.removeItem("user_email");
      localStorage.removeItem("admin_id");
      localStorage.removeItem("changeCatalogPermission");
      this.$router.push("/");
    },
  },
  created() {
    this.admin = localStorage.getItem("admin_name");
  },
};
</script>

<style scoped>
.link {
  text-decoration: none;
  font-size: 16px;
  color: #38485c;
  font-weight: 500;
}

.text-blue {
  color: #247fec;
}

.active-page {
  font-weight: 600;
  color: #007bff;
  cursor: default;
}
</style>


// WEBPACK FOOTER //
// src/components/Layout/Navigation/Navbar.vue